export default __webpack_public_path__ + "static/media/Kami Duong - Comic Designer.6bc94b86.jpg";